<template>
  <div>
    <ed-movimento :intCabecalhoMovimentoId="$route.params.intId" :intTipoMovimentoId="1443" :key="$root.$session.versao+'1443'"/>
  </div>
</template>

<script>
import EdMovimento from "@/components/movimento/index";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdMovimento},
  mounted() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>